export const MOBILE_BREAKPOINT = 768; // this breakpoint switches to desktop UI
export const AJAX_TIMEOUT = 30000;
export const RETRY_INTERVAL = 10000;
export const CLOSE_MODAL_TIMEOUT = 10000;
export const REFRESH_INTERVAL = 60000;
export const NOTIFICATION_REFRESH_INTERVAL = 300000;
export const READ_RECEIPT_TIMEOUT = 5000;
export const SAVE_EDITOR_CONTENT_TIMEOUT = 300;
export const USER_AVATAR_IMG_SIZE = {
  big: '160',
  medium: '80',
  small: '48',
};
export const DEFAULT_LATITUDE = '12.961443';
export const DEFAULT_LONGITUDE = '77.64435000000003';
